/**
 * Create an editor code split to optimize bundle size.
 *
 * @param cb
 */
const LazyEditor = (cb) => {
	// This MUST NOT be ./Editor - it would bypass the package.json->container.js, therefore stripping the component of the container.
	import(/* webpackChunkName: "loadable-EditorContainer" */ './container').then((Editor) =>
		cb(Editor.default),
	);
};
export default LazyEditor;
